import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { GlobalStyle, Container, Description, CircleButton, DescriptionBody, TitleBody } from "../../../../common";
import { SessionController } from "../../infra/controller/session.controller";
import { SessionModel } from "../../applications/domain/session";
import { Load } from "../../../../common/load/load";
import { Workout } from "../../../workouts/application/domain/workout";
import { Action } from "../../../actions/application/domain/actions";
import { ActionsBarWrapper, Wrapper } from "./style";
import { SessionControl } from "./session-control";
import { useRealtimeChannel } from "../../../../common/services/realtime/realtime-hook";
import { ArrowDirection, StimulusType, arrowStimulusMessage, ARROW_HIDE_COMMAND } from "../../../../common/services/realtime/stimulus-types";
import { SessionExecutionMenu } from "./session-execution-menu";
import { ArrowControls } from "./arrow-controls";
import { DrillCode } from "../../../drills/application/domain/drill-code";
import { ResolveDrillCodeUseCase } from "../../../drills/application/usecases/actions/resolve-drill-code.usecase";

export const SessionsExecutionUi = () => {
    const { sessionId } = useParams<{ sessionId: string }>();
    const { publish } = useRealtimeChannel<string>(sessionId ?? "");
    const [session, setSession] = useState<SessionModel | null>(null);
    const [workout, setWorkout] = useState<Workout | null>(null);
    const [actions, setActions] = useState<Action[]>([]);
    const [currentAction, setCurrentAction] = useState<Action | null>(null);
    const [load, setLoad] = useState<boolean>(false);
    const [drillCode, setDrillCode] = useState<DrillCode>(DrillCode.COLOR_DASH);
    const [selectedArrow, setSelectedArrow] = useState<ArrowDirection | null>(null);
    useEffect(() => {
        if (!sessionId) return;
        (async () => {
            try {
                setLoad(true);
                const response = await SessionController.getAllData(sessionId);
                setSession(response.session);
                setWorkout(response.workout);
                setActions(response.actions);
                setDrillCode(await ResolveDrillCodeUseCase.execute(response.workout.drillId));
                setLoad(false);
            } catch (error) {
                setLoad(false);
            }
        })();
    }, [sessionId]);

    const handleSelectArrow = (direction: ArrowDirection) => {
        setSelectedArrow(direction);
        if (sessionId) {
            publish(arrowStimulusMessage(direction));
        }
    };

    const handleHideArrows = () => {
        setSelectedArrow(null);
        if (sessionId) {
            publish(ARROW_HIDE_COMMAND);
        }
    };

    const isArrowDrill = drillCode === DrillCode.ARROW_RIGHT_LEFT;

    return (
        <>
            <GlobalStyle />
            <Container>
                {load && <Load />}
                <SessionExecutionMenu />

                <Wrapper>
                    <TitleBody>{workout?.name}</TitleBody>
                    <DescriptionBody>
                        {session?.name}
                    </DescriptionBody>

                    {isArrowDrill ? (
                        <ArrowControls selected={selectedArrow} onSelect={handleSelectArrow} onHide={handleHideArrows} />
                    ) : (
                        <>
                        {currentAction ?
                            <SessionControl currentAction={currentAction} />
                            : <Description align="center" margintop="80px">
                                Selecione uma ação abaixo <br /> para iniciar a sessão
                            </Description>}

                        <ActionsBarWrapper role="toolbar">
                            {actions.map((action) => (
                                <CircleButton
                                    key={action.id}
                                    color={action.color}
                                    onClick={() => {
                                        setCurrentAction(action);
                                        if (sessionId) {
                                            const payload = `${StimulusType.ACTION_COLOR}_${action.color}`;
                                            publish(payload);
                                        }
                                    }}
                                    selected={currentAction?.id === action.id}
                                />
                            ))}
                        </ActionsBarWrapper>
                        </>
                    )}
                </Wrapper>
            </Container>
        </>
    );
};